<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 5: Emergency &amp; Jurisdictional Contacts</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-12 medium-12 small-12 bold text-align-center">Jurisdictional Emergency Contacts for the Well Site</div>
  <div class="cell large-4 medium-4 small-4 bold">&nbsp;</div>
  <div class="cell large-4 medium-4 small-4 text-align-center bold">Name</div>
  <div class="cell large-4 medium-4 small-4 text-align-center bold">Phone # (<span class="red">Not 911</span>)</div>
  <ng-container formGroupName="fire">
    <div class="cell large-4 medium-4 small-4 bold text-align-right padding-right">Fire Department:<span [ngClass]="{'red': form?.get('fire')?.invalid }">*</span></div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <input type="text" formControlName="name" />
      @if (fieldHasNotes('contacts|fire|name') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|fire|name'" [notes]="getFilteredNotes('contacts|fire|name')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <help-text [helpText]="validationHelpText" [alert]="form?.get('fire').invalid"></help-text>
      <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="phone" />
      @if (fieldHasNotes('contacts|fire|phone') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|fire|phone'" [notes]="getFilteredNotes('contacts|fire|phone')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
  </ng-container>
  <ng-container formGroupName="police">
    <div class="cell large-4 medium-4 small-4 bold text-align-right padding-right">Sheriff's Office or Police Department:<span [ngClass]="{'red': form?.get('police')?.invalid }">*</span></div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <input type="text" formControlName="name" />
      @if (fieldHasNotes('contacts|police|name') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|police|name'" [notes]="getFilteredNotes('contacts|police|name')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <help-text [helpText]="validationHelpText" [alert]="form?.get('police').invalid"></help-text>
      <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="phone" />
      @if (fieldHasNotes('contacts|police|phone') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|police|phone'" [notes]="getFilteredNotes('contacts|police|phone')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
  </ng-container>
  <ng-container formGroupName="medical">
    <div class="cell large-4 medium-4 small-4 bold text-align-right padding-right">Closest Medical Facility:<span [ngClass]="{'red': form?.get('medical')?.invalid }">*</span></div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <input type="text" formControlName="name" />
      @if (fieldHasNotes('contacts|medical|name') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|medical|name'" [notes]="getFilteredNotes('contacts|medical|name')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <help-text [helpText]="validationHelpText" [alert]="form?.get('medical').invalid"></help-text>
      <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="phone" />
      @if (fieldHasNotes('contacts|medical|phone') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|medical|phone'" [notes]="getFilteredNotes('contacts|medical|phone')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
  </ng-container>
  <ng-container formGroupName="emaDirector">
    <div class="cell large-4 medium-4 small-4 bold text-align-right padding-right">County EMA Director<span class="padding-left"><help-text [helpText]="validationHelpText" [alert]="form?.get('emaDirector').invalid"></help-text></span>:</div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <input type="text" formControlName="name" />
      @if (fieldHasNotes('contacts|emaDirector|name') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emaDirector|name'" [notes]="getFilteredNotes('contacts|emaDirector|name')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <span><input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="phone" /></span>
      @if (fieldHasNotes('contacts|emaDirector|phone') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emaDirector|phone'" [notes]="getFilteredNotes('contacts|emaDirector|phone')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
  </ng-container>
  <ng-container formGroupName="planningCommittee">
    <div class="cell large-4 medium-4 small-4 bold text-align-right padding-right">Local Emergency Planning Committee<span class="padding-left" ><help-text [helpText]="validationHelpText" [alert]="form?.get('planningCommittee').invalid"></help-text></span>:</div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <input type="text" formControlName="name" />
      @if (fieldHasNotes('contacts|planningCommittee|name') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|planningCommittee|name'" [notes]="getFilteredNotes('contacts|planningCommittee|name')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-4 medium-4 small-4 input-section">
      <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="phone" />
      @if (fieldHasNotes('contacts|planningCommittee|phone') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|planningCommittee|phone'" [notes]="getFilteredNotes('contacts|planningCommittee|phone')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
  </ng-container>
  <div class="cell large-12 medium-12 small-12 bold text-align-center">24 Hour Emergency Contact</div>
  <ng-container formGroupName="emergency">
    <div class="cell large-3 medium-3 small-3 bold text-align-right padding-right">
      Company Name<span [ngClass]="{ 'red': form?.get('emergency')?.get('company')?.invalid }">*</span>:
      @if (fieldHasNotes('contacts|emergency|company') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emergency|company'" [notes]="getFilteredNotes('contacts|emergency|company')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-3 medium-3 small-3">
      <input type="text" formControlName="company" />
    </div>
    <div class="cell large-3 medium-3 small-3 bold text-align-right padding-right">
      Contact Name<span [ngClass]="{ 'red': form?.get('emergency')?.get('contact')?.invalid }">*</span>:
      @if (fieldHasNotes('contacts|emergency|contact') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emergency|contact'" [notes]="getFilteredNotes('contacts|emergency|contact')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-3 medium-3 small-3">
      <input type="text" formControlName="contact" />
    </div>
    <div class="cell large-3 medium-3 small-3 bold text-align-right padding-right">
      Title<span [ngClass]="{ 'red': form?.get('emergency')?.get('title')?.invalid }">*</span>:
      @if (fieldHasNotes('contacts|emergency|title') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emergency|title'" [notes]="getFilteredNotes('contacts|emergency|title')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-3 medium-3 small-3">
      <input type="text" formControlName="title" />
    </div>
    <div class="cell large-3 medium-3 small-3 bold text-align-right padding-right">
      Phone Number<span class="padding-left"><help-text [helpText]="validationHelpText" [alert]="form?.get('emergency')?.get('phone')?.invalid"></help-text></span>:
      @if (fieldHasNotes('contacts|emergency|phone') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emergency|phone'" [notes]="getFilteredNotes('contacts|emergency|phone')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-3 medium-3 small-3">
      <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" formControlName="phone" />
    </div>
    <div class="cell large-3 medium-3 small-3 bold text-align-right padding-right">
      Email Address<span [ngClass]="{ 'red': form?.get('emergency')?.get('email')?.invalid }">*</span>:
      @if (fieldHasNotes('contacts|emergency|email') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'contacts|emergency|email'" [notes]="getFilteredNotes('contacts|emergency|email')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell large-3 medium-3 small-3">
      <input type="text" formControlName="email" />
    </div>
  </ng-container>
</div>